import httpService from './httpService';

const getAboutMe = async () => {
  const {
    data
  } = await httpService.post('graphql', {
    query: `query {
      aboutMe {
        GeneralInformation
        Icon
        Title
        Description1
        Description2
        Description3
        Avatar {
          url
        }
      }
    }`
  });

  return data.data.aboutMe;
};

const getSkillsTitle = async () => {
  const {
    data
  } = await httpService.post('graphql', {
    query: `query {
      itsKillsTitle {
        Icon,
        Title
      }
    }`
  });

  return data.data.itsKillsTitle;
};

const getSkills = async () => {
  const {
    data
  } = await httpService.post('graphql', {
    query: `query {
      skillsborders {
        SkillName
        SkillPercentage
        SkillLogo {
          url
        }
        SkillCircleColor
        SkillColorBackground
        SkillColor1
        SkillColor2
      }
    }`
  });

  return data.data.skillsborders;
};

const getProjectTitle = async () => {
  const {
    data
  } = await httpService.post('graphql', {
    query: `query {
      projectsTitle {
        Icon
        Title
      }
    }`
  });

  return data.data.projectsTitle;
};

const getProjects = async () => {
  const {
    data
  } = await httpService.post('graphql', {
    query: `query {
      projects {
        ProjectName
        ProjectFunction
        ProjectDescription
        ProjectLogo {
          url
        }
      }
    }`
  });

  return data.data.projects;
};

const getContact = async () => {
  const {
    data
  } = await httpService.post('graphql', {
    query: `query {
      contact {
        Icon
        Title
        FirstLastName
        Email
        Message
      }
    }`
  });

  return data.data.contact;
};

const getFooter = async () => {
  const {
    data
  } = await httpService.post('graphql', {
    query: `query {
      footer {
        Copyright
      }
    }`
  });

  return data.data.footer;
};

const apiService = {
  getAboutMe,
  getSkillsTitle,
  getSkills,
  getContact,
  getProjectTitle,
  getProjects,
  getFooter
};

export default apiService;